import { useParams } from "react-router-dom";
import { Layout } from "antd";
import { createStyles } from "antd-style";

import { usePublicCompany } from "@av/apps/common-apps/platform/services/companies/public-company";
import { CompanyLogo } from "@av/components/molecules/logo/CompanyLogo";
import { JobsLanguageSelector } from "../molecules/JobsLanguageSelector";

interface JobsWebHeaderProps {
  testIdPrefix?: string;
}

const useStyles = createStyles(({ token, css }) => ({
  header: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${token.marginSM}px;
    height: 104px;
    padding: 0;
    background: transparent;
    line-height: normal;
    box-shadow: none;
    border: none;
    background: ${token.colorTextLightSolid};
  `,
}));

export function JobsWebHeader({ testIdPrefix = "public-jobs-web-header" }: JobsWebHeaderProps) {
  const { Header } = Layout;
  const { styles } = useStyles();
  const { companyId } = useParams();
  const { data: publicCompany } = usePublicCompany(companyId);

  return (
    <Header className={styles.header} data-testid={testIdPrefix}>
      <CompanyLogo size="small" testIdPrefix={testIdPrefix} company={publicCompany} />
      <JobsLanguageSelector />
    </Header>
  );
}
